import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook personalizado para hacer scroll al top automáticamente cuando cambia la ruta
 * @param {Object} options - Opciones de configuración para el scroll
 * @param {string} options.behavior - Comportamiento del scroll ('smooth', 'auto', 'instant')
 * @param {number} options.top - Posición vertical a la que hacer scroll
 * @param {number} options.left - Posición horizontal a la que hacer scroll
 */
const useScrollToTop = (options = {}) => {
  const location = useLocation();

  const { behavior = 'smooth', top = 0, left = 0 } = options;

  useEffect(() => {
    window.scrollTo({
      top,
      left,
      behavior
    });
  }, [location.pathname, top, left, behavior]);
};

export default useScrollToTop;
